export default __webpack_public_path__ + "static/media/e_wdt_c_4.bb08b8ce.mp3";